import api from '../interceptor/axios';

export const descargarFichero = async (id, name, slug, mimeType = 'application/octet-stream') => {

    const generarSlug = (nombre, slug) => {

        //la extension la sacamos del slug
        let extension = '';
        if (slug) {
            extension = slug.split('.').pop();
        }

        return nombre
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^\w\-\.]+/g, '') // permite punto para extensiones
            .replace(/\-\-+/g, '-')
            .replace(/^-+/, '')
            .replace(/-+$/, '')
            + '.' + extension;
    };

    const nombreDescarga = generarSlug(name, slug);

    try {
        const response = await api.post(
            process.env.REACT_APP_REST_URL + "descargarFichero.php",
            { id: id },
            { responseType: 'arraybuffer' }
        );

        const blob = new Blob([response.data], { type: mimeType });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', nombreDescarga);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        throw error;
    }
};
